var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReason1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C12.553 5 13 5.447 13 6V11.876C13 12.225 12.819 12.547 12.521 12.73L8.113 15.426C7.951 15.526 7.77 15.572 7.592 15.572C7.255 15.572 6.927 15.402 6.738 15.093C6.45 14.622 6.598 14.007 7.07 13.718L11 11.315V6C11 5.447 11.447 5 12 5ZM22 13H18C17.447 13 17 13.447 17 14C17 14.553 17.447 15 18 15H20.568L16.239 19.328C16.046 19.521 15.705 19.522 15.51 19.328L14.406 18.224C13.455 17.271 11.798 17.271 10.844 18.224L6.791 22.294C6.401 22.686 6.403 23.319 6.794 23.709C6.989 23.903 7.245 24 7.5 24C7.757 24 8.014 23.901 8.209 23.706L12.261 19.636C12.454 19.443 12.795 19.442 12.99 19.636L14.094 20.74C15.045 21.693 16.704 21.692 17.654 20.74L22 16.395V18.999C22 19.552 22.447 19.999 23 19.999C23.553 19.999 24 19.552 24 18.999V14.999C24 13.896 23.103 12.999 22 12.999V13ZM2 12C2 6.486 6.486 2 12 2C16.828 2 20.964 5.44 21.835 10.181C21.936 10.724 22.451 11.09 22.999 10.984C23.542 10.884 23.901 10.363 23.802 9.82C22.757 4.13 17.793 0 12 0C5.383 0 0 5.383 0 12C0 15.316 1.392 18.516 3.818 20.778C4.01 20.958 4.256 21.047 4.5 21.047C4.768 21.047 5.034 20.941 5.231 20.729C5.608 20.326 5.585 19.693 5.181 19.316C3.16 17.43 1.999 14.764 1.999 12.001L2 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason1);
export default __webpack_public_path__ + "static/media/reason1.fb3eb70a8bbd1b5c6a6010af931dacae.svg";
export { ForwardRef as ReactComponent };